// the link columns render open so desktop (and no-JS visitors) always see
// every link; on mobile they become accordions with only the first open
class FooterBenchmark extends HTMLElement {
  connectedCallback() {
    this.desktop = window.matchMedia('(min-width: 990px)');
    this.sync = () => {
      this.querySelectorAll('details.footer-benchmark__column').forEach((column, index) => {
        column.open = this.desktop.matches || index === 0;
      });
    };
    this.sync();
    this.desktop.addEventListener('change', this.sync);

    // the information column renders a Manage Cookies button; reopen the
    // tinycookie consent bar like footer.js does for the other footers
    this.onClick = (event) => {
      if (!event.target.closest('.js-manage-cookie-button')) return;
      let cookieBar = document.querySelector('#tinycookie-wrapper');
      // the app drops the bar from the dom once consent is recorded, so a
      // second visit has to ask it to build one before there is anything to show
      if (!cookieBar && window.Shopify?.tinycookie) {
        window.Shopify.tinycookie.loadCookieBar();
        cookieBar = document.querySelector('#tinycookie-wrapper');
      }
      if (!cookieBar) return;

      cookieBar.style.display = 'block';
      // theme.liquid hides the bar on small product and cart screens so it
      // cannot sit over the sticky buy bar; a visitor who asked for it wins
      cookieBar.classList.add('tinycookie-manual');
    };
    this.addEventListener('click', this.onClick);
  }

  disconnectedCallback() {
    this.desktop.removeEventListener('change', this.sync);
    this.removeEventListener('click', this.onClick);
  }
}

customElements.define('footer-benchmark', FooterBenchmark);
